export { NuevoViajeRevisionCobranzaModelEdit } from "./edit/modal";



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/modales/nuevoviaje/index.tsx